import { SYSBaseElement, html } from "../../../../../../../_ovlclient/src"

import { T, D } from "../../../../../../../_ovlclient/src/global/globals"
import type { SYSState } from "../../../../../../../_ovlclient/src"

export class CompOrderTimeLine extends SYSBaseElement {
  async getUI() {
    let key = this.state.app.screens.DATOrder.orderDetailFormState.selectedOrder
    let order = this.state.app.screens.DATOrder.orderDetail.orders[key]

    return html`
      <div class="timelinegrid">
        <div class="fd-layout-panel ovl-nomargin">
          <div class="fd-layout-panel__header timelinenextarrow">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                ${T("DATDocumentDataOrderConfirm")}
              </h3>
              <p class="fd-layout-panel__description">
                ${order.steps.step1.date !== null ? T("GENSendDate") : ""}
                <b>${D(order.steps.step1.date)}</b>
              </p>
            </div>
          </div>
          <div class="fd-layout-panel__body">
            ${order.orderType === "own"
              ? html`<comp-filelist
                  .props=${(s: SYSState) => {
                    return {
                      fileList:
                        s.app.screens.DATOrder.orderDetail.orders[key].steps
                          .step1.attachments.files,
                      title: "",
                    }
                  }}
                ></comp-filelist>`
              : undefined}
          </div>
        </div>
        <div class="fd-layout-panel ovl-nomargin">
          <div class="fd-layout-panel__header timelinenextarrow">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                ${T("DATDocumentDataOrderPrepare")}
              </h3>
              <p class="fd-layout-panel__description">
                ${order.steps.step2.date !== null ? T("GENSendDate") : ""}
                <b>${D(order.steps.step2.date)}</b>
              </p>
            </div>
          </div>
          <div class="fd-layout-panel__body">
            ${order.orderType === "own"
              ? html`
                  <comp-filelist
                    .props=${(s: SYSState) => {
                      return {
                        fileList:
                          s.app.screens.DATOrder.orderDetail.orders[key].steps
                            .step2.attachments.files,
                        title: "",
                      }
                    }}
                  ></comp-filelist>
                `
              : undefined}
          </div>
        </div>
        <div class="fd-layout-panel ovl-nomargin">
          <div class="fd-layout-panel__header timelinenextarrow">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                ${T("DATDocumentDataOrderProduction")}
              </h3>
            </div>
          </div>
          <div class="fd-layout-panel__body ">
            <comp-filelist
              .props=${(s: SYSState) => {
                return {
                  fileList:
                    s.app.screens.DATOrder.orderDetail.orders[key].steps.step3
                      .attachments.files,
                  title: "",
                }
              }}
            ></comp-filelist>
          </div>
        </div>

        <div class="fd-layout-panel ovl-nomargin">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                ${T("DATDocumentDataOrderDelivery")}
              </h3>
              <p class="fd-layout-panel__description">
                ${order.steps.step4.date !== null ? T("GENSendDate") : ""}
                <b>${D(order.steps.step4.date)}</b>
              </p>
            </div>
          </div>
          <div class="fd-layout-panel__body">
            ${order.orderType === "own"
              ? html`
                  <comp-filelist
                    <comp-filelist
                    .props=${(s: SYSState) => {
                      return {
                        fileList:
                          s.app.screens.DATOrder.orderDetail.orders[key].steps
                            .step4.attachments.files,
                        title: "",
                      }
                    }}
                  ></comp-filelist>
                `
              : undefined}
          </div>
        </div>
      </div>
    `
  }
}
